function get_unique_id(attribute)
{
    var $ = jQuery.noConflict();
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for( var i=0; i < 5; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    var selector = '#'+text;
    if(attribute != undefined) {
        selector = '['+attribute+'="'+text+'"]';
    }
    if($(selector).length>0) {
        return get_unique_id(attribute);
    }
    return text;
}
function setRealCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function setCookie(cname, cvalue, exdays) {
    // localStorage.setItem('cookies',null);
    var cookies = localStorage.getItem('cookies');
    if(cookies == null) {
        cookies = {};
    } else {
        cookies = JSON.parse(cookies);
    }
    if(cookies == null) {
        cookies = {};
    }
    if(cookies[cname] == undefined) {
        cookies[cname] = {};
    }
    cookies[cname].data = cvalue;
    var d = new Date();
    if(exdays == undefined) {
        exdays = 1;
    }
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    cookies[cname].expires = d.getTime();
    localStorage.setItem('cookies', JSON.stringify(cookies));

    // var d = new Date();
    // if(exdays == undefined) {
    //     exdays = 1;
    // }
    // d.setTime(d.getTime() + (exdays*24*60*60*1000));
    // var expires = "expires="+ d.toUTCString();
    // document.cookie = cname + "=" + JSON.stringify(cvalue) + ";" + expires + ";path=/";
}
function deleteCookie(cname) {
    let cookies = localStorage.getItem('cookies');
    if(cookies == null) {
        cookies = {};
    } else {
        cookies = JSON.parse(cookies);
    }
    if(cookies == null) {
        cookies = {};
    }
    if(cookies[cname] !== undefined) {
        delete cookies[cname];
    }
    localStorage.setItem('cookies', JSON.stringify(cookies));

    // document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
function getCookie(cname, ifNull) {
    var cookies = localStorage.getItem('cookies');
    if(cookies == null) {
        cookies = {};
    } else {
        cookies = JSON.parse(cookies);
    }
    if(cookies == null) {
        cookies = {};
    }

    if(cookies[cname]) {
        var exp = cookies[cname].expires;
        if(new Date().getTime() <= exp) {
            return cookies[cname].data;
        } else {
            var new_obj = {};
            for(var key in cookies) {
                if(key === cname) {
                    continue;
                }
                new_obj[key] = cookies[key];
            }
            localStorage.setItem('cookies', JSON.stringify(new_obj));
        }
    }
    return ifNull;

    // var name = cname + "=";
    // var ca = document.cookie.split(';');
    // for(var i = 0; i <ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0)==' ') {
    //         c = c.substring(1);
    //     }
    //     if (c.indexOf(name) == 0) {
    //         return JSON.parse(c.substring(name.length,c.length));
    //     }
    // }
    // return ifNull;
}
function get_events(elm) {
    return jQuery._data(elm[0],'events');
}
function has_event(elm, event_name) {
    var events = get_events(elm);

    var namespace = null;
    if(event_name.split('.').length > 1) {
        namespace = event_name.split('.')[1];
        event_name = event_name.split('.')[0];
    }

    if(events[event_name] != undefined) {
        if(namespace != null) {
            return events[event_name][0].namespace == namespace;
        }
        return true;
    }
    return false;
}
function place_events(events, destination) {
    var $ = jQuery.noConflict();
    // Iterate through all event types
    $.each(events, function(eventType, eventArray) {
        // Iterate through every bound handler
        $.each(eventArray, function(index, event) {
            // Take event namespaces into account
            var eventToBind = event.namespace.length > 0
                ? (event.type + '.' + event.namespace)
                : (event.type);

            // Bind event
            console.log({eventToBind:eventToBind,event:event});
            destination.bind(eventToBind, event.data, event.handler);
        });
    });
}
function reload_location_if_needed(close, callback = null, reloadCurrent = true) {
    //Check if you're on the last opened popup, then reload
    //If you're not, close your popup and reload the previous one
    const $ = jQuery.noConflict();
    const reveals = $('.reveal-overlay:visible');
    const count = reveals.length;

    if(close === undefined) {
        close = true;
    }


    //Reload window wrapper
    var w = $('.window-wrapper');
    var doneLoading = '*';
    if(w.length > 0) {
        var doneLoading = '*:not(body)';
        $('body').isLoading();
        let url = window.location.toString();
        if (url.split('?').length === 1) {
            url += '?';
        }
        url += '&leaveFlashes=1';
        $.get(url, function(html) {
            var new_html = $($.parseHTML('<div>'+html+'</div>'));

            $('.sidebar ul:first').replaceWith(new_html.find('.sidebar ul:first'));
            if (!reload_dashboard_widgets($)) {
                w.replaceWith(new_html.find('.window-wrapper'));
                $('.window-wrapper').find("input[type='checkbox']:not([name^='filters'])").removeAttr('checked');
                init_calendar($);
            }


            if (callback !== null) {
                callback();
            } else {
                $('body').doneLoading();
            }

            if(close === true) {
                var current;
                reveals.each(function(i) {
                    current = $(this);
                });
                if(current != undefined) {
                    try {
                        current.find('.reveal').foundation('close');
                    } catch(e) {
                        // console.log(e);
                    }
                }
            }
        });
    } else if (callback !== null) {
        const closeEventUid = get_unique_id();
        $('[data-reveal]').on('closed.zf.reveal.' + closeEventUid, function () {
            var modal = $(this);
            $('body').isLoading();
            $('[data-reveal]').unbind('closed.zf.reveal.' + closeEventUid);
            callback();
        });
    }

    const boardClosed = !($('body').hasClass('data-input-open'));
    const preventLocationReload = $('body').is('[data-prevent-location-reload]');

    if(count === 1 && w.length === 0 && boardClosed && !preventLocationReload) {
        location.reload();
    } else if(count > 1) {
        $(doneLoading).doneLoading();
        const others = [];
        // var last;
        let current;
        reveals.each(function(i) {
            current = $(this);
            if(count !== i+1) {
                others.push($(this));
            }
        });
        if(close === true) {
            current.find('.reveal').foundation('close');
            close = false;
        } else if (reloadCurrent) {
            current.find('.reveal').squdeReloadAjaxPopup();
            //This log fixes stuff...
            // console.log(current.find('.reveal').attr('id'));
        }
        others.forEach(function(other) {
            other.find('.reveal').squdeReloadAjaxPopup();
        })
        // last.find('.reveal').squdeReloadAjaxPopup();
    } else if(close === false && reloadCurrent) {
        reveals.find('.reveal').squdeReloadAjaxPopup();
    } else {
        try {
            reveals.find('.reveal').foundation('close');
        } catch(e) {
            console.warn('Tried closing, didn\'t work');
        }
    }

    if (!boardClosed || preventLocationReload) {
        $('table.scrollable-table:visible').reloadThisElement();

        $('body').doneLoading();
    }
}
function redirect_and_do(url, callback, hard = false, metaData = {}) {
    const $ = jQuery.noConflict();
    if (hard === true) {
        if (!callback) {
            callback = function() {};
        }
        localStorage.setItem('afterLoad', callback.toString());
        localStorage.setItem('afterLoadData', JSON.stringify(metaData));

        window.location.href = url;
    } else {
        $.get(url, function(html) {
            const new_html = $($.parseHTML('<div>'+html+'</div>'));
            window.history.pushState({}, '', url);

            $('.sidebar > ul:not([style])').replaceWith(new_html.find('.sidebar > ul:not([style])'));
            $('.page-container').replaceWith(new_html.find('.page-container'));
            $('.screen-buttons-wrapper').replaceWith(new_html.find('.screen-buttons-wrapper'));
            $('.window-wrapper').find("input[type='checkbox']:not([name^='filters'])").removeAttr('checked');

            loadAllScreenButtons($);
            init_calendar($);
            $('body').doneLoading();

            squde_reload_for_flashes();

            if (typeof callback === 'function') {
                callback();
            }
        });
    }
}
function clone_and_attach_parent(self, selector) {
    var $ = jQuery.noConflict();
    var elm = $(self);
    var parent = elm.parents(selector);
    var clone = parent.clone(true,true);
    var container = parent.parent();
    clone.find('input[type="text"], input[type="url"], input[type="email"], input[type="password"]').val('');
    clone.find('select').each(function() {
        var first_val = $(this).find('option:first').attr('value');
        $(this).val(first_val);
    });
    clone.find('input[type="checkbox"], input[type="radio"]').removeAttr('checked');
    container.append(clone);

    return false;
}
function remove_parent_row(self, selector) {
    var $ = jQuery.noConflict();
    var elm = $(self);
    var parent = elm.parents(selector);
    setTimeout(function() {
        // parent.remove();
    },100);

    return false;
}
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};
function camelize(str) {
    str = str.replaceAll('-',' ');
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return (index == 0 ? match.toLowerCase() : match.toUpperCase());
    });
}
function leadingZero(number, length) {
    if (length === undefined) {
        length = 2;
    }
    let str = number.toString();
    while(str.length < length) {
        str = '0' + str;
    }
    return str;
}
function view_customer(obj) {
    if (obj.last_name !== undefined) {
        view_contact(obj.id);
    } else {
        view_company(obj.id);
    }
}
function open_new_object(open_fn, data) {
    if (typeof data === 'string') {
        data = JSON.parse(data);
    }
    if (typeof data === 'object' && data.id) {
        open_fn(data.id);
    }
}
/**
 * Returns the week number for this date.  dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
Date.prototype.getWeek = function () {
    /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */

    const dowOffset = 1; //default dowOffset to zero
    var newYear = new Date(this.getFullYear(),0,1);
    var day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = (day >= 0 ? day : day + 7);
    var daynum = Math.floor((this.getTime() - newYear.getTime() -
        (this.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
    var weeknum;
    //if the year starts before the middle of a week
    if(day < 4) {
        weeknum = Math.floor((daynum+day-1)/7) + 1;
        if(weeknum > 52) {
            let nYear = new Date(this.getFullYear() + 1,0,1);
            let nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
              the week, it is week #1 of that year*/
            weeknum = nday < 4 ? 1 : 53;
        }
    }
    else {
        weeknum = Math.floor((daynum+day-1)/7);
    }
    return weeknum;
};

function add_fields_to_form(form, extraData, prefix) {
    form.find('[data-hidden-create-fields]').remove();
    if (prefix === undefined) {
        prefix = '';
    }
    for (let key in extraData) {
        // noinspection JSUnfilteredForInLoop
        const value = extraData[key];
        // noinspection JSUnfilteredForInLoop
        let name = key;
        if (prefix.length > 0) {
            name = prefix + '[' + name + ']';
        }

        if (typeof value === 'object') {
            add_fields_to_form(form, value, name);
        } else {
            const input = jQuery('<input type="hidden" data-hidden-create-fields />');
            input.attr('name', name);
            input.val(value);
            form.append(input);
        }
    }
}

function readable_date(date, format = 'DD-MM-YYYY') {
    const momentObject = new moment(date);
    return momentObject.format(format);
}
